import { Injectable } from '@angular/core';
import { Widget } from '../../shared/widget/widget';
import { AuthenticationService } from './authentication.service';
import { LogCategory, LogCoreService, LoggerService, LogType } from './logger.service';
declare let dataLayer: object[];

@Injectable()
export class TagManagerService {

    constructor(
        private logger: LoggerService,
        private auth: AuthenticationService
    ) {
        this.log("constructor", null, LogCategory.Constructor);
    }
    private log(method: string = null, message = null, category: LogCategory = LogCategory.Default): void {
        method = (method) ? '.' + method + '()' : '';
        message = (message) ? message.toString() : '';
        this.logger.try(this.constructor.name + method + ': ' + message, LogType.CoreService, LogCoreService.TagManager, category);
    }

    // KEEP THIS METHOD PRIVATE -- In order to carefully control the string values of things like category, action,
    // etc, keep this method private and only call the more targeted methods below. This will help prevent a whole
    // bunch of junk getting added to GTM and allows the methods below to tightly control the string values. 
    private gaEvent(action: string, target: string, value: string = ""): void {
        // KEEP THIS METHOD PRIVATE -- see above
        this.log("gaEvent", `dataLayer.push() kfEvent: ${this.auth.audience}; ${action}; ${target}; ${value}`);
        dataLayer.push({
            'event': 'kfEvent',
            'kfEvent': {
                'category': this.auth.audience,
                'action': action,
                'label': target,
                'value': value
            }
        });
    }

    public gaWidgetFave(widget: Widget): void {
        this.gaEvent('favorite', `${widget.module}: ${widget.meta.Name}`, widget.IsFave.toString() );
    }
    public gaWidgetResize(widget: Widget): void {
        this.gaEvent('resize', `${widget.module}: ${widget.meta.Name}`, widget.Size.toString());
    }
    public gaWidgetCollapse(widget: Widget): void {
        this.gaEvent('collapse', `${widget.module}: ${widget.meta.Name}`, widget.IsCollapsed.toString());
    }
    public gaAnnouncementDismissed(widget: Widget, id: string): void {
        this.gaEvent('dismiss', `${widget.module}: ${widget.meta.Name} - ${id}`);
    }
    public gaLinkClicked(category: string, title: string): void {
        this.gaEvent('link', `${category}: ${title}`);
    }
    public gaLinkFave(category: string, title: string, isFave:boolean): void {
        this.gaEvent('favorite', `${category}: ${title}`, isFave.toString());
    }
    public gaSearch(searchType: string): void {
        this.gaEvent('search', `${searchType}`);
    }
    public gaDownload(downloadType: string): void {
        this.gaEvent('download', `${downloadType}`)
    }
    
}
